import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, Space, Tag, Divider, Badge } from 'antd';
import { CrownOutlined, LockOutlined, RightOutlined, CheckCircleOutlined, FireOutlined, StarOutlined } from '@ant-design/icons';
import { BECOME_VIP_URL } from '../../../config/globalConfig';

interface VipUpgradeCardProps {
  vipBlogName: string;
  showCard?: boolean;
}

const VipUpgradeCard: React.FC<VipUpgradeCardProps> = ({ vipBlogName, showCard = true }) => {
  const navigate = useNavigate();

  if (!showCard) {
    return null;
  }

  return (
    <Card
      style={{
        margin: '20px auto',
        maxWidth: '700px',
        textAlign: 'center',
        background: 'linear-gradient(135deg, #fffcf3 0%, #fff2d8 100%)',
        borderColor: '#ffc069',
        borderWidth: 0,
        borderRadius: '20px',
        boxShadow: '0 15px 35px rgba(255, 169, 64, 0.25), 0 5px 15px rgba(255, 169, 64, 0.1)',
        overflow: 'hidden',
        position: 'relative',
      }}
      bodyStyle={{ padding: '32px 28px' }}
    >
      {/* 背景装饰 */}
      <div className="card-decoration"></div>
      
      {/* 金色边框装饰 */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '8px',
        background: 'linear-gradient(90deg, #ffd666, #ffa940, #fa8c16, #ffa940, #ffd666)',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }} />
      
      {/* 热门标签 */}
      <div className="hot-tag">
        <FireOutlined style={{ marginRight: '4px', fontSize: '14px' }} />
        限时特惠
      </div>
      
      {/* 闪光效果 */}
      <div className="sparkle sparkle-1"></div>
      <div className="sparkle sparkle-2"></div>
      <div className="sparkle sparkle-3"></div>
      
      <Space direction="vertical" size="large" style={{ width: '100%', position: 'relative', zIndex: 2 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="crown-container">
            <CrownOutlined style={{ fontSize: '28px', color: 'white' }} />
            <div className="crown-glow"></div>
          </div>
          <h2 className="vip-title">
            解锁VIP尊享特权
          </h2>
        </div>
        
        <p style={{ 
          color: '#8c8c8c', 
          margin: '0 0 12px',
          fontSize: '15px',
          maxWidth: '480px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>
          <LockOutlined style={{ marginRight: '8px', color: '#fa8c16' }} />
          升级VIP会员，立即获取完整市场分析和专家级投资策略
        </p>
        
        {/* VIP特权标签 */}
        <div className="vip-tags">
          <Tag className="vip-tag">
            <CheckCircleOutlined /> 机会识别
          </Tag>
          <Tag className="vip-tag">
            <CheckCircleOutlined /> 币种分析
          </Tag>
          <Tag className="vip-tag">
            <CheckCircleOutlined /> 交易策略
          </Tag>
          <Tag className="vip-tag">
            <CheckCircleOutlined /> 社群支持
          </Tag>
        </div>
        
        {/* 价格标签 */}
        <div className="price-container">
          <Badge.Ribbon text="限时优惠" color="#ff7a45" placement="start">
            <div className="price-tag">
              <div className="price-old">原价 2999u/年</div>
              <div className="price-new">
              <span className="price-value">1000</span>
                <span className="price-symbol">u</span>
                <span className="price-period">/年</span>
              </div>
            </div>
          </Badge.Ribbon>
        </div>
        
        <Divider style={{ margin: '16px 0', borderColor: '#ffd591', opacity: 0.6 }} />
        
        <Button 
          type="primary" 
          size="large"
          icon={<RightOutlined />}
          onClick={() => navigate(BECOME_VIP_URL)} 
          className="vip-button"
        >
          立即升级 · 畅享VIP特权
        </Button>
        
        <div className="user-count">
          <StarOutlined style={{ marginRight: '6px', color: '#ffc53d' }} />
          已有超过100位用户选择升级VIP
        </div>
      </Space>
      
      {/* 添加CSS样式 */}
      <style>
        {`
          .card-decoration {
            position: absolute;
            top: -50px;
            right: -50px;
            width: 200px;
            height: 200px;
            background: radial-gradient(circle, rgba(255, 214, 102, 0.3) 0%, rgba(255, 214, 102, 0) 70%);
            border-radius: 50%;
            z-index: 1;
          }
          
          .hot-tag {
            position: absolute;
            top: 0;
            right: 0;
            background: linear-gradient(135deg, #ff7a45 0%, #fa541c 100%);
            color: white;
            padding: 8px 18px;
            borderBottomLeftRadius: 16px;
            fontSize: 14px;
            fontWeight: bold;
            boxShadow: 0 4px 12px rgba(250, 84, 28, 0.4);
            display: flex;
            alignItems: center;
            clip-path: polygon(0 0, 100% 0, 100% 100%, 15% 100%);
            z-index: 3;
          }
          
          .crown-container {
            background: linear-gradient(135deg, #ffd666 0%, #fa8c16 100%);
            border-radius: 50%;
            width: 56px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 18px;
            box-shadow: 0 6px 16px rgba(250, 140, 22, 0.4);
            position: relative;
            transform: perspective(800px) rotateY(-10deg);
            transition: all 0.3s ease;
          }
          
          .crown-container:hover {
            transform: perspective(800px) rotateY(0deg);
          }
          
          .crown-glow {
            position: absolute;
            top: -5px;
            left: -5px;
            right: -5px;
            bottom: -5px;
            background: radial-gradient(circle, rgba(255, 214, 102, 0.8) 0%, rgba(255, 214, 102, 0) 70%);
            border-radius: 50%;
            filter: blur(8px);
            animation: pulse 2s infinite;
            z-index: -1;
          }
          
          .vip-title {
            font-weight: bold;
            font-size: 32px;
            margin: 0;
            background: linear-gradient(90deg, #d46b08, #fa8c16);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            text-shadow: 0 2px 4px rgba(0,0,0,0.05);
            letter-spacing: 1px;
            position: relative;
          }
          
          .vip-tags {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 10px;
          }
          
          .vip-tag {
            color: #873800;
            background-color: #fff7e6;
            border-color: #ffd591;
            padding: 6px 14px;
            border-radius: 6px;
            font-size: 14px;
            box-shadow: 0 2px 6px rgba(255, 169, 64, 0.15);
            transition: all 0.3s;
          }
          
          .vip-tag:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(255, 169, 64, 0.25);
          }
          
          .price-container {
            margin: 8px auto;
            width: fit-content;
          }
          
          .price-tag {
            background: rgba(255, 247, 230, 0.7);
            border: 1px dashed #ffd591;
            border-radius: 12px;
            padding: 8px 24px;
            display: inline-block;
          }
          
          .price-old {
            text-decoration: line-through;
            color: #bfbfbf;
            font-size: 14px;
          }
          
          .price-new {
            display: flex;
            align-items: baseline;
            justify-content: center;
          }
          
          .price-symbol {
            font-size: 18px;
            font-weight: bold;
            color: #fa541c;
          }
          
          .price-value {
            font-size: 32px;
            font-weight: bold;
            color: #fa541c;
            margin: 0 2px;
          }
          
          .price-period {
            font-size: 14px;
            color: #8c8c8c;
          }
          
          .vip-button {
            background: linear-gradient(90deg, #fa8c16, #ff7a45);
            border-color: #fa8c16;
            border-radius: 12px;
            font-weight: bold;
            height: 52px;
            font-size: 16px;
            box-shadow: 0 8px 20px rgba(250, 140, 22, 0.45);
            transition: all 0.3s;
            width: 80%;
            max-width: 360px;
            margin: 0 auto;
            position: relative;
            overflow: hidden;
          }
          
          .vip-button:hover {
            transform: translateY(-3px) scale(1.02);
            box-shadow: 0 12px 24px rgba(250, 140, 22, 0.55) !important;
          }
          
          .vip-button:after {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: linear-gradient(
              to bottom right,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.1) 50%,
              rgba(255, 255, 255, 0) 100%
            );
            transform: rotate(45deg);
            animation: shine 3s infinite;
          }
          
          .user-count {
            font-size: 14px;
            color: #8c8c8c;
            margin-top: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .sparkle {
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #ffd666;
            box-shadow: 0 0 10px 2px #ffd666;
            z-index: 1;
          }
          
          .sparkle-1 {
            top: 30%;
            left: 15%;
            animation: float 3s ease-in-out infinite;
          }
          
          .sparkle-2 {
            top: 20%;
            right: 25%;
            animation: float 4s ease-in-out infinite 1s;
          }
          
          .sparkle-3 {
            bottom: 25%;
            right: 10%;
            animation: float 5s ease-in-out infinite 0.5s;
          }
          
          @keyframes pulse {
            0% { opacity: 0.6; transform: scale(0.95); }
            50% { opacity: 1; transform: scale(1.05); }
            100% { opacity: 0.6; transform: scale(0.95); }
          }
          
          @keyframes shine {
            0% { left: -100%; opacity: 0; }
            20% { left: 100%; opacity: 0.5; }
            100% { left: 100%; opacity: 0; }
          }
          
          @keyframes float {
            0% { transform: translateY(0) scale(1); opacity: 0.7; }
            50% { transform: translateY(-10px) scale(1.2); opacity: 1; }
            100% { transform: translateY(0) scale(1); opacity: 0.7; }
          }
        `}
      </style>
    </Card>
  );
};

export default VipUpgradeCard; 